var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-note"},[_c('NoteEditForm',{attrs:{"isEdit":true,"form":_vm.form},on:{"editNote":function($event){return _vm.$emit('updateNote', $event)},"deleteNote":function($event){return _vm.$emit('deleteNote', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }